import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { GpsNotificationComponent } from '../gps-notification/gps-notification.component';
import { Notification } from 'src/app/core/interfaces/notification';
import { ModalEnum } from 'src/app/core/enums/modal.enum';

@Component({
  selector: 'app-gps-tracking-alert',
  templateUrl: './gps-tracking-alert.component.html',
  styleUrls: ['./gps-tracking-alert.component.scss']
})
export class GpsTrackingAlertComponent implements OnInit {
  @Output() close = new EventEmitter<void>();
  @Input() notification: Notification | null = null;
  constructor(private dialog: MatDialog) { }

  ngOnInit() {
  }

  onClose() {
    this.close.emit();
  }

  openGpsDetailsDialog() {
    const config = new MatDialogConfig();
    config.data = this.notification || null;
    config.maxHeight = ModalEnum.MAX_HEIGHT;
    config.width = ModalEnum.LARGE_WIDTH;
    config.maxWidth = ModalEnum.MAX_WIDTH;
    config.autoFocus = false;
    config.disableClose = false;
    this.dialog.open(GpsNotificationComponent, config);
  }

}
